import { render, staticRenderFns } from "./NoMessageSelected.vue?vue&type=template&id=ef526768&scoped=true&"
import script from "./NoMessageSelected.vue?vue&type=script&lang=js&"
export * from "./NoMessageSelected.vue?vue&type=script&lang=js&"
import style0 from "./NoMessageSelected.vue?vue&type=style&index=0&id=ef526768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef526768",
  null
  
)

export default component.exports